/**
 * Created By Elia Rohana on 1/20/19
 */
import { initialState } from '../state';
import { BpmnProcessCreatorActionTypes, BpmnProcessErrorActions } from '../actions';

export function bpmnDeploymentError(state = initialState.bpmnDeploymentError, action: BpmnProcessErrorActions): string {
    switch (action.type) {
        case BpmnProcessCreatorActionTypes.SAVE_BPMN_XML_FAILURE: {
            return  action.payload.error;
        }
        default: {
            return state;
        }
    }
}
